import React, {ReactNode, createContext, useEffect, useState} from "react";
import { Session } from "types";
import { initAssessment, updateAssessmentValue, updateAssessmentData } from "api/webservice/assessment";
import { getIn } from "utils/json";

type AssessmentContextType = {
  responses: any[];
  getValue: (tags: string[]) => any;
  saveResponse: (tags: string[], updateValue: any) => void;
  saveDataResponse: (tags: string[], updateValue: any) => void;
  setResponses: (responses: any[]) => void;
  isAuthorizedForIAssert: boolean;
  setIsAuthorizedForIAssert: (isAuthorizedForIAssert: boolean) => void;
  loading: boolean;
};

interface Props {
  children: ReactNode;
  session: Session;
}

export const AssessmentContext = createContext<AssessmentContextType>(null!);

export const AssessmentProvider: React.FC<Props> = ({ children, session }: Props) => {
  const [responses, setResponses] = useState<Array<any>>([]);
  const [isAuthorizedForIAssert, setIsAuthorizedForIAssert] = useState(false);
  const [loading, setLoading] = useState(true);

  //create the IAssert if it doesn't already exist, or fetch it if it does
  useEffect(() => {
    initAssessment(session.id, session.user_id)
      .then((responses) => {
        setIsAuthorizedForIAssert(true);
        if (responses != undefined) {
          setResponses(responses.assessment_json);
          setLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        setIsAuthorizedForIAssert(false);
      });
  },[]);

  // get value from locally cached resopnse values;
  const getValue = (tags: string[]) => getIn(responses, tags);

  // save values to database and update locally cached response values from database;
  const saveResponse = (tags: string[], updateValue: any) => {
    updateAssessmentValue(session.id, session.user_id, tags, updateValue)
      .then(() => { return initAssessment(session.id, session.user_id) })
      .then((responses) => setResponses(responses.assessment_json))
    // TODO implement retry logic
      .catch(err => console.error("retry logic not implemented yet on saveResponse for assessments", err))
  }

  // save values to database and update locally cached response values from database;
  const saveDataResponse = (tags: string[], updateData: any) => {
    updateAssessmentData(session.id, session.user_id, tags, updateData)
      .then(() => { return initAssessment(session.id, session.user_id) })
      .then((responses) => setResponses(responses.assessment_json))
    // TODO implement retry logic
      .catch(err => console.error("retry logic not implemented yet on saveDataResponse for assessments", err))
  }

  return (
    <AssessmentContext.Provider
      value={{
        responses,
        setResponses,
        getValue,
        saveResponse,
        saveDataResponse,
        isAuthorizedForIAssert,
        setIsAuthorizedForIAssert,
        loading
      }}
    >
      {children}
    </AssessmentContext.Provider>
  );
}
